
/* Stylesheets */
import "./scss/vendors/bootstrap.scss"; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
//import "./scss/vendors/swiper.scss"; // ref: https://swiperjs.com/get-started#installation
import "./scss/vendors/hamburgers.scss"; // ref: https://jonsuh.com/hamburgers/#sass
import "./scss/vendors/energy-saver.scss";
//import "aos/src/sass/aos.scss";
import "./scss/fonts.scss";
import "./scss/forms.scss";
import "./scss/style.scss";

/* Game */
import { initStartScreen, initGhostScene } from './game.js';

/* Scripts */
const imagesLoaded = require('imagesloaded');

import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
import { faEye } from '@fortawesome/pro-light-svg-icons';
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { faEnvelopeCircleCheck } from '@fortawesome/pro-light-svg-icons';
library.add(faEye, faEyeSlash, faAngleDown, faEnvelopeCircleCheck);
dom.i2svg();

//*****************************************************************
//****************** function from functions.js *******************
//*****************************************************************

//custom function (essential)
import { showLoading, hideLoading, initMenuFocusTrap, initFormValidation, setFocusOnElement, showHidePassword, scrollToElm, scrollToHash, scrollToFirstErr, urlHasHash, initCleave, initCookieScriptAccessibility } from './functions.js';

//custom function (additional)
/*import { initEnergySaver, showSpinner, hideSpinner, initAOS, initSwiper, showCustomModal, showVideoModalYT } from './functions.js';*/
import { initEnergySaver } from './functions.js';

/* Export functions (essential) */
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.initMenuFocusTrap = initMenuFocusTrap;
window.initFormValidation = initFormValidation;
window.setFocusOnElement = setFocusOnElement;
window.showHidePassword = showHidePassword;
window.scrollToElm = scrollToElm;
window.scrollToHash = scrollToHash;
window.scrollToFirstErr = scrollToFirstErr;
window.urlHasHash = urlHasHash;
window.initCleave = initCleave;
window.initCookieScriptAccessibility = initCookieScriptAccessibility;
//window.showCustomModal = showCustomModal;
//window.showVideoModalYT = showVideoModalYT;

//(additional)
window.initEnergySaver = initEnergySaver;
window.initStartScreen = initStartScreen;
window.initGhostScene = initGhostScene;
//window.showSpinner = showSpinner;
//window.hideSpinner = hideSpinner;
//window.initAOS = initAOS;
//window.initSwiper = initSwiper;

//*****************************************************************
//*****************************************************************
//*****************************************************************

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
	if (document.readyState != "loading") callback();
	else document.addEventListener("DOMContentLoaded", callback);
};
const isDebug = process.env.NODE_ENV !== "production";
const initWebpackVersion = () => {
	isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

window.addEventListener("hashchange", (event) => {
	urlHasHash();
});

//resize
window.addEventListener("resize", () => {

});

//scroll
window.addEventListener("scroll", function () {

});

/* Ready callback function */
ready(() => {

	//(essential)
	initWebpackVersion();
	initMenuFocusTrap();
	initFormValidation();
	showHidePassword();
	urlHasHash();
	initCleave();
	initCookieScriptAccessibility();

	//(additional)
	//initEnergySaver();
	//initAOS();
	//initSwiper();

	// Attende che tutte le immagini all'interno del <body> siano completamente caricate
	imagesLoaded('body', function () {
		hideLoading();
	});

	// Seleziona tutti i link all'interno del <nav> e aggiunge un event listener per il click
	Array.from(document.querySelectorAll('nav a'))
		.forEach((element) => element.addEventListener('click', (evt) => {
			// Estrae il valore dell'ancora (hash) dall'attributo href (es. "#sezione1" -> "sezione1")
			var hrefvalue = element.getAttribute('href').split('#')[1];
			// Estrae l'hash corrente dall'URL della finestra (es. "#sezione1" -> "sezione1")
			var hashvalue = window.location.hash.split('#')[1];
			// Se esiste un hash in href e corrisponde a quello gi� presente nell'URL
			if (hrefvalue !== undefined && hrefvalue === hashvalue) {
				// Richiama una funzione personalizzata per gestire lo scroll manuale alla sezione
				scrollToHash(hashvalue);
			}
		}));

	// Aggiunge un event listener per il clic sull'elemento con classe .hamburger (icona menu)
	document.querySelector('.hamburger').addEventListener('click', function (e) {
		e.preventDefault(); // Previene il comportamento predefinito (utile se l'elemento � un <a> o simili)
		// Alterna la classe .is-active sull'icona hamburger (ad esempio per animarla in "X")
		this.classList.toggle('is-active');
		// Alterna la classe .is-active sul menu di navigazione (mostra/nasconde la barra)
		document.querySelector('.item-nav').classList.toggle('is-active');
		// Alterna la classe .nav-is-active sul <body> (utile per modificare lo sfondo, impedire lo scroll, ecc.)
		document.body.classList.toggle('nav-is-active');
		
		const isExpanded = this.getAttribute('aria-expanded') === 'true'; // Controlla lo stato attuale di aria-expanded
		if (isExpanded) {
			// Se era espanso (true), ora si sta chiudendo, quindi impostiamo "Apri il menu"
			this.setAttribute('aria-label', 'Apri il menu');
		} else {
			// Se non era espanso (false), ora si sta aprendo, quindi impostiamo "Chiudi il menu"
			this.setAttribute('aria-label', 'Chiudi il menu');
		}
	});

	// Seleziona tutti gli elementi che hanno l'attributo [aria-expanded]
	// e li trasforma in un array per poter usare forEach
	Array.from(document.querySelectorAll('[aria-expanded]'))
		.forEach((element) =>
			// Aggiunge un event listener per il click su ciascun elemento
			element.addEventListener('click', (evt) => {
				// Recupera il valore corrente di aria-expanded (true o false)
				// e lo inverte: se � "true" diventa "false", altrimenti diventa "true"
				element.setAttribute(
					'aria-expanded',
					element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
				);
			})
		);
});